<template>
    <div>
        <label><input type="checkbox" v-model="block.showInNavigation" ref="showInNavigation"> In Navigation anzeigen</label>
        <text-input :value="block.name" label="Name" ref="name"></text-input>
        <long-text-input :value="block.text" label="Text" ref="text"></long-text-input>
        <key-results v-model="block.keyResults" :results="project.results"/>
        <button class="btn btn-primary" @click="save">Save</button>
    </div>
</template>
<script>
import KeyResults from "../KeyResults";

export default {
  components: {
    KeyResults
  },
  props: ["project", "blockData"],
  data() {
    return {
      showCreateModal: false,
      block: this.blockData,
      keyResultName: ""
    };
  },
  methods: {
    save() {
      let form = new FormData();
      for (let i = 0; i < this.block.keyResults.length; i++) {
        form.append(
          "edit_project_products_block[keyResults][" + i + "]",
          this.block.keyResults[i].id
        );
      }
      if (this.block.showInNavigation)
        form.append(
          "edit_project_products_block[showInNavigation]",
          this.block.showInNavigation
        );
      form.append("edit_project_products_block[submit]", 1);

      Promise.all([
        this.$refs.name.save(),
        this.$refs.text.save(),
        axios.post(
          "/api/" + store.state.language + "/block/" + this.block.id + "/edit",
          form
        )
      ]).then(responses => {});
    }
  }
};
</script>
<style>
.card {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Blocks/ProjectProductsBlock.vue